import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin, from, of, Subscription } from 'rxjs';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SolicitudCreditoServiceWorkflow } from '../../../../shared/services/solicitud-credito-workflow.service';
import { catchError, filter, map, mergeMap, toArray } from 'rxjs/operators';
import { ESystemAccess } from 'src/app/enum/EAccess';
import { SessionService } from 'src/app/shared/services/session.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { IReporteBasico } from 'src/app/models/reporte-buscar/reporte-buscar.model';
import { ICarpetaTributariaElectronicaReporteModel } from 'src/app/models/reporte-full/reporte-full.model';
import { IPoderJudicialGetReportReponse } from 'src/app/interface/IPoderJudicialGetReportReponse';
import { IBoletinConcursalCreateReportResponse } from 'src/app/interface/IBoletinConcursalCreateReportResponse';
import { isNumber } from 'lodash';
import { IEmpresaEnUnDia } from 'src/app/models/empresa-en-un-dia/empresa-en-un-dia.model';
import { balanceReporteFullResumenFinanciero } from 'src/app/models/utils/utils.model';
import { Chart } from 'angular-highcharts';
import { RutFormatPipe } from 'src/app/shared/pipes/rutFormat.pipe';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { CurrencyPipe, DecimalPipe, TitleCasePipe } from '@angular/common';

interface TreeNode {
    name: string;
    children?: TreeNode[];
}

interface FlatNode {
    expandable: boolean;
    name: string;
    level: number;
}

@Component({
    selector: 'app-plantilla-larrain',
    templateUrl: './plantilla-larrain.component.html',
    styleUrls: ['./plantilla-larrain.component.scss'],
    providers: [RutFormatPipe, DecimalPipe, TitleCasePipe, CurrencyPipe]
})
export class PlantillaLarrainComponent {
    @Input() plantillaNoEditable = false;
    @Input() objEntradaFicha: any = {};
    @Input() objEntradaMotor: any = {};

    @Output() operacionNuevo = new EventEmitter<boolean>();
    @Output() finalizarFlujo = new EventEmitter<void>();
    @Output() bloqueaPasos5 = new EventEmitter<boolean>();
    @Output() bloqueaPasos6 = new EventEmitter<boolean>();
    @Input() idTransaccion = '';
    @Input() stepper!: number;
    @Input() rut = '';
    @Input() closed = true;

    private access: string[] = [
        ESystemAccess.FLUJO_CREDITO_BUSCAR,
        ESystemAccess.FLUJO_CREDITO_BUSCAR_ADMIN,
        ESystemAccess.FLUJO_CREDITO,
        ESystemAccess.FLUJO_CREDITO_ADMIN
    ];

    public readonly SIN_INFORME_TEXT = 'Reporte Basico - Sin Informe Comercial' as const;

    public objectKeys = Object.keys;
    public subscriptions: Subscription[] = [];
    public data: any;
    public today = '';
    public bodyModelos: any = {};

    public groupNameConsulting: string[] = ['buscarReportePrincipal'];
    public groupNameConsultingFicha: string[] = ['buscarFichaDeCredito', 'buscarReportePrincipal'];

    public listaReportesPrincipales: any[] = [];
    public errores: any[] = [];
    public reportesPrincipalesObj: any = {};

    public consolidadoTitular: any = {};
    public reportesSeleccionado: any = {};
    public informeComercial = '';

    public reportePoderJudicial: any = null;
    public reporteDeudaSbif: any = null;
    public reporteBoletinConcursal: any = null;
    public reporteCteVentasBalancesRentas: any = null;
    public reporteBasicReport: any = null;
    public reporteBienesRaices: any = null;
    public reporteVehiculos: any = null;

    public showReportes = false;

    public fichaGuardada: any = {}; // es para validar la existencia de una ficha guardada y habilitar el boton continuar

    public objReporteBasico: IReporteBasico | null = null;
    public objReporteFinanciero: ICarpetaTributariaElectronicaReporteModel | null = null;
    public objReporteJudicial: IPoderJudicialGetReportReponse | null = null;
    public objReporteBoletinConcursal: IBoletinConcursalCreateReportResponse | null = null;
    public objReporteEmpresaDia: IEmpresaEnUnDia | null = null;

    public objReporteRegCheq: any | null = null;

    public objResumenDeudaSbif: any = {};

    public mallaSocietaria = '';
    public periodoDeuda = '';
    public totalJudicial = 0;

    public resumenFinancieroData: any[] = [];
    public resumenFinancieroColumns: string[] = ['concepto'];
    public periodosResumenFinanciero: string[] = [];
    public balanceReporteFullResumenFinanciero: typeof balanceReporteFullResumenFinanciero | any = balanceReporteFullResumenFinanciero;
    public informacionBalance: any;
    public headerResumenFinanciero: string[] = [
        'ingresosdelaExplotacion',
        'utilidadneta',
        'utilidadVentas',
        'razonCorriente',
        'permanenciaCtasporCobrar',
        'permanenciadeInventarios',
        'totalactivos',
        'totalactivosfijos',
        'totalpasivoexigible',
        'totalpatrimonio',
        'leverage',
        'ebitda',
        'ebitdagf'
    ];

    public riesgoIndustriaCalculado = "";
    public graph: any = {};

    public isPersonaNatural = false;
    public reporteConInformeComercial = false;
    public telefonos: any[] = [];
    public direccion = '';

    // ================================
    // Angular Material Tree - Datos y Configuración
    // ================================

    public antecedentesSocietariosTree: TreeNode[] = [];
    public sociosTree: TreeNode[] = [];

    private _transformer = (node: TreeNode, level: number) => {
        return {
            expandable: !!node.children && node.children.length > 0,
            name: node.name,
            level: level,
        };
    };

    treeControl = new FlatTreeControl<FlatNode>(
        node => node.level,
        node => node.expandable,
    );

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        node => node.level,
        node => node.expandable,
        node => node.children,
    );

    private antecedentesSocietariosDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    private sociosDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    public dataSourceSocios!: MatTreeFlatDataSource<any, any>;

    // Fin de Angular Material Tree

    public antecedentesComercialesData: any[] = [];
    public antecedentesComercialesColumns = ['concepto', 'montoMiles', 'cantidad'];

    public antecedentesSociedadesData: any[] = [];
    public antecedentesSociedadesColumns = ['Rut', 'Nombre'];

    public documentosTimbradosData: any[] = [];
    public documentosTimbradosColumns = ['documento', 'anoUltimoTimbraje'];

    public observacionesTributariasData: any[] = [];
    public observacionesTributariasColumns = ['nombre', 'descripcion'];

    public consultasRutData: any[] = [];
    public consultasRutColumns = ['FechaConsulta', 'RazonSocial', 'InformeConsultado'];

    public morosidadesProtestosData: any[] = [];
    public morosidadesProtestosColumns = [
        'fechaVencimiento',
        'tipoDocumento',
        'monto',
        'localidad',
        'librador',
        'tipoDeuda',
        'mercado',
        'tipoCredito',
        'nChequeOperacion',
        'fechaPublicacion',
    ];

    public boletinLaboralData: any[] = [];
    public boletinLaboralColumns = [
        'motivo',
        'meses',
        'institucion',
        'boletin',
        'monto',
        'pagina',
        'insp',
        'fecha',
        'tipoInfraccion',
        'resolutionNumber',
    ];

    constructor(
        public alertService: AlertService,
        private solicitudCreditoService: SolicitudCreditoServiceWorkflow,
        private spinner: NgxSpinnerService,
        private _sessionService: SessionService,
        public utilsService: UtilsService,
        private rutFormatPipe: RutFormatPipe,
        private numberPipe: DecimalPipe,
        private currencyPipe: CurrencyPipe,
        private titleCasePipe: TitleCasePipe,
    ) {
        this.antecedentesSocietariosDataSource.data = this.antecedentesSocietariosTree;
        this.sociosDataSource.data = this.sociosTree;
    }

    ngOnInit(): void {
        this.operacionNuevo.emit(false);
        this.setToday();
        if (this.plantillaNoEditable === false) {
            this.obtenerFlujo();
        }
    }

    hasChild = (_: number, node: FlatNode) => node.expandable;

    setToday(): void {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }

    obtenerFlujo(): void {
        this.spinner.show();
        this.subscriptions.push(this.solicitudCreditoService.obtenerFlujo(this.idTransaccion, this.rut).subscribe(resp => {
            this.bodyModelos = resp;
            let paso: any;
            let pasoAnterior: any;
            const pasosCompleted = resp.stages.filter((e: any) => e.completed);
            const cantidad = pasosCompleted.length;
            const ultimoPasoCompletado = Number(pasosCompleted[cantidad - 1].stageID);
            this.closed = (resp.closed === null || resp.closed === undefined) ? true : resp.closed;

            if (this.stepper === 5) {
                resp.stages.forEach((e: any) => {
                    if (e.stageID === '10') {
                        paso = e;
                    }
                });
                // Se valida si el paso anterior fue completado y si no se envia al ultimo completado
                if (paso?.stageID === '10' && (paso?.completed === false && paso?.optional === false)) { //pasoAnterior && !pasoAnterior?.completed
                    let pasoAnteriorCompleted = ultimoPasoCompletado;
                    if (ultimoPasoCompletado === 9)
                        pasoAnteriorCompleted = 8;

                    this.redireccionPasoAnterior(pasoAnteriorCompleted);
                } else {
                    if (paso?.stageID === '10' && paso?.completed === true) { // Se realizo el calculo del score
                        this.callServices(true);
                    } else {
                        this.redireccionPasoAnterior(ultimoPasoCompletado);
                    }
                }
            } else {
                resp.stages.forEach((e: any) => {
                    if (e.stageID === '9') {
                        paso = e;
                    } else if (e.stageID === '8') {
                        pasoAnterior = e;
                    }
                });
                // Se valida si el paso anterior fue completado y si no se envia al ultimo completado
                if (pasoAnterior && (!pasoAnterior?.completed && pasoAnterior?.optional === false)) {
                    this.redireccionPasoAnterior(ultimoPasoCompletado);
                } else {
                    if (paso?.stageID === '9' && paso?.completed === false) { // primera vez en esta pantalla -> cambiar para pruebas
                        this.callServices();
                    }
                    else if (paso?.stageID === '9' && paso?.completed === true) { // ya se habia llegado antes a esta pantalla -> cambiar para pruebas
                        this.callServices(true); // --> solo si se avanza en el flujo
                    }
                }
            }
        }, (error: any) => {
            this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrió un error al recuperar los datos del flujo de crédito');
            this.spinner.hide();
        }));

    }

    async callServices(fichaGuardada = false): Promise<void> {
        const apiServices: any = [];

        if (!fichaGuardada) {
            if (this.groupNameConsulting.length > 0) {
                for await (const value of this.groupNameConsulting) {
                    apiServices.push(this.getServices(value))
                }
            }
        } else {
            if (this.groupNameConsultingFicha.length > 0) {
                for await (const value of this.groupNameConsultingFicha) {
                    apiServices.push(this.getServices(value))
                }
            }
        }

        this.spinner.show();
        this.subscriptions.push(forkJoin(apiServices).subscribe((resp) => {
            this.spinner.hide();
            if (this.errores.length > 0) {
                this.errores.forEach((element: any) => {
                    this.alertService.error(element.msg);
                });
                this.spinner.hide();
            } else {
                if (!fichaGuardada) {
                    this.buscarReportes("callServices");
                } else {
                    this.buscarReportes("callServicesFicha");
                }
            }
        },
            (error) => {
                this.alertService.error(error.message);
                this.spinner.hide();
            }
        ));
    }

    setError(reporte: string, error: string): void {
        this.errores.push({
            id: reporte,
            msg: error
        })
    }

    setResponse(service: string, response: any): void {
        if (service === 'buscarReportePrincipal') {
            this.listaReportesPrincipales = response?.ReportKeys || [];
        } else if (service === 'buscarFichaDeCredito') {
            this.fichaGuardada = response?.FichaDeCredito;
            const ficha = JSON.parse(JSON.stringify(response?.FichaDeCredito?.ficha));

            (ficha && Object.keys(ficha).length > 0) ? this.showReportes = true : this.showReportes = false;
        }
    }

    mapeoFromFicha(ficha: any): void {
        this.consolidadoTitular = ficha?.consolidadoTitular || {};
        this.setReportValues();
        this.generarReporteBasicoConsolidado();
    }

    getServices(service: string): any {
        const objeto: any = {
            'buscarReportePrincipal': () => {
                return this.solicitudCreditoService.buscarReportePrincipal(this.idTransaccion, this.rut)
                    .pipe(
                        map(resp => {
                            this.setResponse(service, resp);
                        })
                    )
                    .pipe(
                        catchError((error) => (this.setError(service, error?.error?.message || 'Solicitud de Crédito - Error Inesperado en servicio de reportes principales'), of(null))));
            },
            'buscarFichaDeCredito': () => {
                return this.solicitudCreditoService.buscarFichaDeCredito(this.idTransaccion, this.rut)
                    .pipe(
                        map(resp => {
                            this.setResponse(service, resp);
                        })
                    )
                    .pipe(
                        catchError((error) => (this.setError(service, error?.error?.message || 'Solicitud de Crédito - Error Inesperado en servicio de carga de ficha'), of(null))));
            },
        };
        return objeto[service]();
    }

    buscarReportes(etapa: string): void {
        const apiServicesReportes: any = this.utilsService.obtenerServicesReportes(this.listaReportesPrincipales, {}) || [];
        let count = 0;

        this.spinner.show();
        from(apiServicesReportes).pipe(
            mergeMap(
                (service: any) =>
                    this.solicitudCreditoService.buscarReportes(
                        this.idTransaccion,
                        this.rut,
                        service.principal,
                        service.reportKey,
                        service.entidad,
                        service.rutDerivado
                    ).pipe(
                        catchError(() => {
                            return of(null);
                        }),
                        map(response => {
                            if (response !== null) {
                                count++;
                            }
                            return {
                                service: service,
                                response: response
                            };
                        }),
                    ),20),
            filter(response => response !== null),
            toArray()
        ).subscribe(responses => {
            if (count === 0) { // Si no hubo respuestas válidas
                this.alertService.error('Solicitud de Crédito - Ha ocurrido un error al consultar la información de todos los reportes');
                this.spinner.hide();
            } else if (count < apiServicesReportes.length) { // Si hubo respuestas válidas pero no para todos los servicios
                this.alertService.error('Solicitud de Crédito - Ha ocurrido un error al consultar la información de algunos de los reportes');
            }
            if (count > 0) {
                this.reportesPrincipalesObj = this.utilsService.mapeoReportesPrincipales(responses);
                if (etapa === 'callServices') {
                    this.mapeoReportes();
                    this.informeComercial = this.utilsService.identificarInformeComercial(this.reportesSeleccionado?.basicReport?.reporte);
                    this.spinner.hide();
                } else if (etapa === 'callServicesFicha') {
                    this.informeComercial = this.utilsService.identificarInformeComercial(this.reportesSeleccionado?.basicReport?.reporte);
                    this.mapeoFromFicha(this.fichaGuardada?.ficha);
                    this.showReportes = true;
                    this.spinner.hide();
                } else {
                    this.spinner.hide();
                }
            }
        }, () => {
            if (count > 0) {
                this.alertService.error('Solicitud de Crédito - Ha ocurrido un error al consultar la información de algunos de los reportes');
            } else {
                this.alertService.error('Solicitud de Crédito - Ha ocurrido un error al consultar la información de todos los reportes');
                this.spinner.hide();
            }
        });
    }

    redireccionPasoAnterior(ultimoPasoCompletado: number): void {
        let step = this.solicitudCreditoService.stepsOptions.filter((e: any) => e.stageID == (ultimoPasoCompletado + 1));
        if (!step[0]?.step) {
            step = this.solicitudCreditoService.stepsOptions.filter((e: any) => e.stageID == (ultimoPasoCompletado));
        }
        this.alertService.error(`Solicitud de Crédito - Debe completar el paso N° ${Number(step[0]?.step)} para poder continuar`);
        this.solicitudCreditoService.setStep(Number(step[0]?.step));
    }

    formateoFecha(fechaEntrada: string): string {
        if (fechaEntrada.includes("T")) {
            const fecha = new Date(fechaEntrada);
            const dia = fecha.getDate().toString().padStart(2, '0');
            const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
            const anio = fecha.getFullYear().toString();
            return `${dia}-${mes}-${anio}`;
        } else {
            return fechaEntrada;
        }
    }

    mapeoReportes(): void {
        const F22Limpio = this.utilsService.obtenerDatosF22(this.reportesPrincipalesObj, true, true, true, true);
        const F29Limpio = this.utilsService.obtenerDatosF29(this.reportesPrincipalesObj, true, true, true);
        const fechaActual = new Date();
        const anio = fechaActual.getFullYear();

        let aniosF29 = [];
        if (F29Limpio.length === 0) {
            aniosF29 = [anio, anio - 1];
        } else if (F29Limpio.length === 1) {
            const anioUnico = F29Limpio[0].periodo ? F29Limpio[0].periodo : anio;
            aniosF29 = [anioUnico, anioUnico - 1];
        } else {
            const aniosUnicos = [...new Set(F29Limpio.map(obj => obj?.periodo))];
            aniosUnicos.sort((a, b) => b - a);

            const anioActual: any = aniosUnicos[0] ? aniosUnicos[0] : (aniosUnicos[1] ? (aniosUnicos[1] + 1) : anio);
            const anioAnterior: any = aniosUnicos[1] ? aniosUnicos[1] : (aniosUnicos[0] ? (aniosUnicos[0] - 1) : anio - 1);

            aniosF29 = [anioActual, anioAnterior];
        }

        let aniosF22 = [];
        if (F22Limpio.length === 0) {
            aniosF22 = [anio, anio - 1];
        } else if (F22Limpio.length === 1) {
            const anioUnicoF22 = F22Limpio[0]?.calculado?.periodo;
            if (anioUnicoF22) {
                aniosF22 = [anioUnicoF22, anioUnicoF22 - 1];
            } else {
                aniosF22 = [anio, anio - 1];
            }
        } else {
            const aniosUnicosF22 = [...new Set(F22Limpio.map(obj => obj?.calculado?.periodo))];
            aniosUnicosF22.sort((a, b) => b - a);
            aniosF22 = [aniosUnicosF22[0], aniosUnicosF22[1]];
        }

        this.consolidadoTitular = this.utilsService.crearConsolidadoTitular(F22Limpio, F29Limpio, this.reportesPrincipalesObj);
        this.consolidadoTitular.regCheq = this.reportesPrincipalesObj.regCheq;

        this.setReportValues();
        this.generarReporteBasicoConsolidado();

        this.showReportes = true;
    }

    generarReporteBasicoConsolidado(): void {
        if (this.reportesPrincipalesObj) {

            this.mapeoReporteTitular();
            this.mapeoBalance();
            this.mapeoPoderJudicial();
            this.mapeoSbif();
            this.validaObjetos();

            if (this.reportesSeleccionado?.poderJudicial?.ReporteFull) {
                this.reportePoderJudicial = this.reportesSeleccionado.poderJudicial.ReporteFull;
            }
            if (this.reportesSeleccionado?.deudaSbif?.reporte) {
                this.reporteDeudaSbif = this.reportesSeleccionado.deudaSbif.reporte;
            }
            if (this.reportesSeleccionado?.boletinConcursal?.reporte &&
                this.reportesSeleccionado?.boletinConcursal?.reporte?.boletinConcursalReporte?.principal?.encabezado &&
                Object.keys(this.reportesSeleccionado?.boletinConcursal?.reporte?.boletinConcursalReporte?.principal?.encabezado).length > 0) {
                this.reporteBoletinConcursal = this.reportesSeleccionado.boletinConcursal.reporte;
            }
            if (this.reportesSeleccionado?.cteVentasBalancesRentas?.reporte) {
                this.reporteCteVentasBalancesRentas = this.reportesSeleccionado.cteVentasBalancesRentas.reporte;
            }
            if (this.reportesSeleccionado?.basicReport?.reporte) {
                this.reporteBasicReport = this.reportesSeleccionado.basicReport.reporte;
            }
            if (this.reportesSeleccionado?.objReporteBienesRaices) {
                this.reporteBienesRaices = this.reportesSeleccionado?.objReporteBienesRaices;
            }
            if (this.reportesSeleccionado?.objReporteVehiculos) {
                this.reporteVehiculos = this.reportesSeleccionado.objReporteVehiculos;
            }

        }
    }

    mapeoSbif(): void {
        const itemSbif: any[] = this.utilsService.mapeoGeneralSbif(this.reportesSeleccionado);
        if(itemSbif && itemSbif.length > 0) {
            this.reportesSeleccionado.deudaSbif.reporte = {
                Documentos: {
                    SbifOnline: {
                        Reporte: {
                            rowsMeses: {
                                item: itemSbif
                            }
                        }
                    }
                }
            }
        }
    }

    mapeoPoderJudicial(): void {
        if(this.reportesSeleccionado?.poderJudicial && Object.keys(this.reportesSeleccionado?.poderJudicial).length > 0){
            this.reportesSeleccionado.poderJudicial = this.utilsService.mapeoPoderJudicial(this.reportesSeleccionado?.poderJudicial);
        }
    }

    mapeoReporteTitular(): void {
        this.reportesSeleccionado = {
            deudaSbif: this.reportesPrincipalesObj?.deudaSbif,
            poderJudicial: this.reportesPrincipalesObj?.poderJudicial,
            boletinConcursal: this.reportesPrincipalesObj?.boletinConcursal,
            objReporteVehiculos: this.reportesPrincipalesObj?.vehiculos?.reporte,
            objReporteBienesRaices: this.reportesPrincipalesObj?.bienesRaices?.reporte,
            cteVentasBalancesRentas: this.reportesPrincipalesObj?.cteVentasBalancesRentas
        }

    }

    validaObjetos(): void {
        if (this.reportesSeleccionado?.cteVentasBalancesRentas?.reporte && Object.keys(this.reportesSeleccionado?.cteVentasBalancesRentas?.reporte).length === 0) {
            this.reportesSeleccionado.cteVentasBalancesRentas.reporte = null;
        }
        if (this.reportesSeleccionado?.basicReport?.reporte && Object.keys(this.reportesSeleccionado?.basicReport?.reporte).length === 0) {
            this.reportesSeleccionado.basicReport.reporte = null;
        }
        if (this.reportesSeleccionado?.deudaSbif?.reporte && Object.keys(this.reportesSeleccionado?.deudaSbif?.reporte).length === 0) {
            this.reportesSeleccionado.deudaSbif.reporte = null;
        }
        if (this.reportesSeleccionado?.boletinConcursal?.reporte && Object.keys(this.reportesSeleccionado?.boletinConcursal?.reporte).length === 0) {
            this.reportesSeleccionado.boletinConcursal.reporte = null;
        }
    }

    mapeoVehiculos(): void {
        if (this.reportesSeleccionado?.vehiculos?.reporte) {
            this.reportesSeleccionado.objReporteVehiculos = this.reportesSeleccionado?.vehiculos?.reporte;
        }
    }

    mapeoBienesRaices(): void {
        if (this.reportesSeleccionado?.bienesRaices?.reporte) {
            this.reportesSeleccionado.objReporteBienesRaices = this.reportesSeleccionado?.bienesRaices?.reporte;
        }
    }

    obtenerSocios(): any[] {
        if (this.reportesPrincipalesObj?.cte?.reporte?.fechaReporte && this.reportesPrincipalesObj?.cteVentasBalancesRentas?.reporte?.fechaReporte) {
            if (this.reportesPrincipalesObj?.cte?.reporte?.fechaReporte >= this.reportesPrincipalesObj?.cteVentasBalancesRentas?.reporte?.fechaReporte) {
                return this.reportesPrincipalesObj?.cte?.reporte?.CarpetaTributariaElectronicaReporte?.Reporte?.socios || [];
            } else {
                return this.reportesPrincipalesObj?.cteVentasBalancesRentas?.reporte?.CarpetaTributariaElectronicaReporte?.Reporte?.socios || [];
            }
        } else {
            if (this.reportesPrincipalesObj?.cte?.reporte?.fechaReporte) {
                return this.reportesPrincipalesObj?.cte?.reporte?.CarpetaTributariaElectronicaReporte?.Reporte?.socios || [];
            } else if (this.reportesPrincipalesObj?.cteVentasBalancesRentas?.reporte?.fechaReporte) {
                return this.reportesPrincipalesObj?.cteVentasBalancesRentas?.reporte?.CarpetaTributariaElectronicaReporte?.Reporte?.socios || [];
            }
        }
        return [];
    }

    mapeoBalance(): void {
        const datosF22: any[] = this.utilsService.obtenerDatosF22(this.reportesPrincipalesObj, true, true, true, true);
        const datosF29: any[] = this.utilsService.obtenerDatosF29(this.reportesPrincipalesObj, true, true, true);
        if (datosF22.length > 0 || datosF29.length > 0) {
            const respuesta: any = {
                CarpetaTributariaElectronicaReporte: {
                    DatosBasicosSolicitud: { Rut: this.rut.slice(0, -1), DV: this.rut.slice(-1) },
                    DatosSolicitante: {},
                    Reporte: {
                        f22: datosF22 || [],
                        f29: datosF29 || [],
                        socios: this.obtenerSocios || [],
                        representantes: []
                    }
                }
            };

            this.reportesSeleccionado.cteVentasBalancesRentas = { reporte: respuesta };
        }
    }

    validaUsuarioAdmin(): boolean {
        return this._sessionService.getUserAccess().includes(this.access[3]);
    }

    volverEtapaPrevia(): void {
        this.bloqueaPasos5.emit(false);
        this.solicitudCreditoService.setStep(Number(this.stepper - 1));
        this.spinner.hide();
    }

    guardarFicha(): void {
        const ficha: any = {
            ficha: {
                consolidadoTitular: this.consolidadoTitular,
            }
        };

        this.spinner.show();
        this.subscriptions.push(this.solicitudCreditoService.guardarFichaDeCredito(this.rut, this.idTransaccion, ficha).subscribe(resp => {
            this.fichaGuardada = ficha;
            this.alertService.success(resp.message)
            this.spinner.hide();
        }, (error: any) => {
            this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrió un error con el servicio de guardado de la ficha');
            this.spinner.hide();
        }));
    }

    avanzarFlujo(): void {
        this.spinner.show();
        this.subscriptions.push(this.solicitudCreditoService.obtenerFlujo(this.idTransaccion, this.rut).subscribe(resp => {
            this.bodyModelos = resp;
            if (this.bodyModelos?.stages[8]?.optional === false) {
                if (this.bodyModelos?.stages[8]?.completed) {

                    this.subscriptions.push(this.solicitudCreditoService.calcularScore(this.idTransaccion, this.rut).subscribe(resp => {
                        if (resp?.MotorDeCalculos?.errors?.hassError === false) {
                            if (resp?.DatosBasicosSolicitud?.Automatico === true) {

                                this.bloqueaPasos6.emit(true);
                                this.solicitudCreditoService.setStep(6);
                                this.spinner.hide();

                            } else {

                                this.solicitudCreditoService.setStep('next');
                                // bloquea pasos 5
                                if (!this.validaUsuarioAdmin()) {
                                    this.bloqueaPasos5.emit(true);
                                }
                                this.spinner.hide();
                            }
                        } else {
                            this.alertService.error(resp?.MotorDeCalculos?.details?.message || 'Solicitud de Crédito - Ocurrió un error al recuperar los datos del motor de calculos');
                            this.spinner.hide();
                        }
                    }, (error: any) => {
                        this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrió un error al consultar servicio del motor de calculos');
                        this.spinner.hide();
                    }));

                } else {
                    this.spinner.hide();
                    this.alertService.error('Solicitud de Crédito - Debe completar la etapa actual para poder avanzar');
                }
            } else {
                this.solicitudCreditoService.setStep('next');
                this.spinner.hide();
            }
        }, (error: any) => {
            this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrió un error al recuperar los datos del flujo de crédito');
            this.spinner.hide();
        }));
    }

    continuar(): void {
        this.spinner.show();
        this.subscriptions.push(this.solicitudCreditoService.obtenerFlujo(this.idTransaccion, this.rut).subscribe(resp => {
            this.bodyModelos = resp;
            if (this.bodyModelos?.stages[9]?.optional === false) {
                if (this.bodyModelos?.stages[9]?.completed) {

                    // Llamada a servicio para inciar aprobacion
                    this.subscriptions.push(this.solicitudCreditoService.iniciarFlujoAprobacional(this.idTransaccion, this.rut).subscribe(resp => {
                        const error = resp?.ServicioAprobacional?.errors || null;
                        if (error?.hassError === true) {
                            this.alertService.error(error?.details?.message || 'Solicitud de Crédito - Ocurrió un error al actualizar el flujo');
                            this.spinner.hide();
                        } else {
                            this.solicitudCreditoService.setStep('next');
                            this.bloqueaPasos6.emit(true);
                            this.spinner.hide();
                        }
                    }, (error: any) => {
                        this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrió un error al consultar con el servicio para iniciar el flujo aprobacional');
                        this.spinner.hide();
                    }));

                } else {
                    this.spinner.hide();
                    this.alertService.error('Solicitud de Crédito - Debe completar la etapa actual para poder avanzar');
                }
            } else {
                // Llamada a servicio para inciar aprobacion
                this.subscriptions.push(this.solicitudCreditoService.iniciarFlujoAprobacional(this.idTransaccion, this.rut).subscribe(resp => {
                    const error = resp?.ServicioAprobacional?.errors || null;
                    if (error?.hassError === true) {
                        this.alertService.error(error?.details?.message || 'Solicitud de Crédito - Ocurrió un error al actualizar el flujo');
                        this.spinner.hide();
                    } else {
                        this.solicitudCreditoService.setStep('next');
                        this.bloqueaPasos6.emit(true);
                        this.spinner.hide();
                    }
                }, (error: any) => {
                    this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrió un error al consultar con el servicio para iniciar el flujo aprobacional');
                    this.spinner.hide();
                }));
            }
        }, (error: any) => {
            this.alertService.error(error?.error?.message || 'Solicitud de Crédito - Ocurrió un error al recuperar los datos del flujo de crédito');
            this.spinner.hide();
        }));
    }

    setReportValues() {
        this.objReporteBasico = this.consolidadoTitular?.objReporteBasico;
        this.setIsPersonaNatural();

        if (this.validarIfInformation(this.objReporteBasico) && this.objReporteBasico?.InformacionBasica?.TipoReporte !== this.SIN_INFORME_TEXT) {
            this.reporteConInformeComercial = true;
        } else {
            this.reporteConInformeComercial = false;
        }

        this.antecedentesSociedadesData = this.objReporteBasico?.AntecedentesSociedades || [];
        this.documentosTimbradosData = this.objReporteBasico?.ObservacionesTributarias?.DocumentosTimbrados || [];
        this.observacionesTributariasData = this.objReporteBasico?.ObservacionesTributarias?.Observaciones || [];
        this.consultasRutData = this.objReporteBasico?.AntecedentesComerciales?.ConsultasAlRut || [];
        this.morosidadesProtestosData = this.objReporteBasico?.AntecedentesComerciales?.DetalleMorosidadesYProtestos || [];
        this.boletinLaboralData = this.objReporteBasico?.AntecedentesComerciales?.InformacionBoletinComercialLaboral || [];

        this.mallaSocietaria = this.consolidadoTitular?.mallaSocietaria;

        this.objReporteFinanciero = null;
        if (this.consolidadoTitular?.objReporteFinanciero && Object.keys(this.consolidadoTitular?.objReporteFinanciero).length > 0) {
            this.objReporteFinanciero = this.consolidadoTitular?.objReporteFinanciero;
        }

        this.setDataSourceSocios();
        if (this.validaObjetoSocios()) {
            this.buildSociosTree(this.objReporteFinanciero);
        } else {
            this.buildAntecedentesSocietariosTree(this.objReporteBasico);
        }

        this.buildAntecedentesComercialesData(this.objReporteBasico);

        this.objReporteJudicial = this.consolidadoTitular?.objReporteJudicial;

        this.objReporteBoletinConcursal = null;
        if (this.consolidadoTitular?.objReporteBoletinConcursal && Object.keys(this.consolidadoTitular?.objReporteBoletinConcursal).length > 0) {
            this.objReporteBoletinConcursal = this.consolidadoTitular?.objReporteBoletinConcursal;
        }

        this.objResumenDeudaSbif = this.consolidadoTitular?.objResumenDeudaSbif?.objResumenDeudaSbif;
        this.periodoDeuda = this.consolidadoTitular?.objResumenDeudaSbif?.periodoDeuda;
        this.totalJudicial = this.consolidadoTitular?.totalJudicial;

        const regCheqReport = this.consolidadoTitular?.regCheq;

        this.objReporteRegCheq = null;
        if (regCheqReport?.reporte && Object.keys(regCheqReport?.reporte).length > 0) {
            this.objReporteRegCheq = this.mapRegCheq(regCheqReport.reporte);
        }

        this.informacionBalance = this.consolidadoTitular?.informacionBalance;

        this.buildResumenAntecedentesFinancieros(this.informacionBalance);

        this.riesgoIndustriaCalculado = this.consolidadoTitular?.reporteBasico?.objRiesgoIndustrialCalculado?.riesgoIndustriaCalculado;

        if (this.consolidadoTitular?.reporteBasico?.graph) {
            this.graph = new Chart(this.consolidadoTitular?.reporteBasico?.graph);
        }

    }

    obtenerRepresentantes(): boolean {
        const representantes = this.objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.Reporte?.representantes;

        if (representantes && representantes.length > 0) return true;

        return false;
    }

    sumarTotalesDeudas([...arr]): number | string {
        return this.objResumenDeudaSbif ? arr.reduce((acc, curr) => acc + this.objResumenDeudaSbif[curr], 0) : 'Sin información';
    }

    obtenerPrincipal(): boolean {
        const principal = this.objReporteBoletinConcursal?.boletinConcursalReporte?.principal;

        if (principal && isNumber(principal) && principal > 0) return true;

        return false;
    }

    setClasificacionPosition(value: string): number {
        if (!value) return 0;
        return Math.round((Number(value) * 100) / 1000);
    }

    validarIfInformation(obj: any): boolean {
        return obj && Object.keys(obj).length > 0;
    }

    validaObjetoAntecedentes(): boolean {
        return !!this.objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.Reporte?.nombre;
    }

    validaObjetoSocios(): boolean {
        return !!this.objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.Reporte?.socios?.length;
    }

    setIsPersonaNatural(): void {
        let rut;
        if (this.objReporteBasico?.InformacionBasica?.Rut) {
            rut = this.objReporteBasico.InformacionBasica.Rut;
        } else {
            rut = this.rut.slice(0, -1);
        }

        if(rut.includes('.')) {
            rut = rut.replace(/\./g, '');
        }

        if (rut.includes('-')) {
            rut = rut.split('-')[0];
        }

        this.isPersonaNatural = Number(rut) > 50000000 ? false : true;

        this.getTelefonos();
        this.getDireccion();
    }

    getDireccion(): void {
        if (this.isPersonaNatural) {
            if (this.objReporteBasico?.InformacionPersonal?.Contactabilidad?.Direcciones && this.objReporteBasico?.InformacionPersonal?.Contactabilidad?.Direcciones.length > 0) {
                const direccionesParticulares: any[] = this.objReporteBasico?.InformacionPersonal?.Contactabilidad?.Direcciones.filter((direccion: any) => direccion.TipoDireccion === 'PARTICULAR');
                if (direccionesParticulares && direccionesParticulares.length > 0) {
                    const direccionPReciente = direccionesParticulares.sort((a: any, b: any) => (a.FechaDireccion < b.FechaDireccion ? 1 : -1))[0];
                    if (direccionPReciente) {
                        this.direccion = `${direccionPReciente.CalleyNumero}${direccionPReciente.Comuna ? ', ' + direccionPReciente.Comuna : ''}${direccionPReciente.Ciudad ? ', ' + direccionPReciente.Ciudad : ''}`;
                        return;
                    }
                }
            }
            this.direccion = this.objReporteBasico?.InformacionBasica?.Direccion || '';
        } else {
            if (this.objReporteBasico?.InformacionBasica?.Direccion) {
                this.direccion = this.objReporteBasico?.InformacionBasica?.Direccion || '';
            }
        }
    }

    public getTelefonos(): void {
        if (this.isPersonaNatural) {
            if (this.objReporteBasico?.InformacionPersonal?.Contactabilidad?.Telefonos && this.objReporteBasico?.InformacionPersonal?.Contactabilidad?.Telefonos.length > 0) {
                if (this.objReporteBasico?.InformacionPersonal?.Contactabilidad?.Telefonos.length <= 2) {
                    this.telefonos = this.objReporteBasico?.InformacionPersonal?.Contactabilidad?.Telefonos || [];
                } else {
                    this.telefonos = this.objReporteBasico?.InformacionPersonal?.Contactabilidad?.Telefonos
                        .sort((a: any, b: any) => (new Date(a.FechaTelefono).getTime() < new Date(b.FechaTelefono).getTime() ? 1 : -1)).slice(0, 2);
                }
            }
        } else {
            if (this.objReporteBasico?.ContactabilidadComercial?.Telefonos && this.objReporteBasico?.ContactabilidadComercial?.Telefonos.length > 0) {
                if (this.objReporteBasico?.ContactabilidadComercial?.Telefonos.length <= 2) {
                    this.telefonos = this.objReporteBasico?.ContactabilidadComercial?.Telefonos || [];
                } else {
                    this.telefonos = this.objReporteBasico?.ContactabilidadComercial?.Telefonos
                        .sort((a: any, b: any) => (new Date(a.FechaTelefono).getTime() < new Date(b.FechaTelefono).getTime() ? 1 : -1)).slice(0, 2);
                }
            }
        }
    }

    formatFechaEmailPN(dateNumber: any): string {
        // Convertir el número a una cadena
        if (!dateNumber) {
            return '';
        }
        const dateString = dateNumber.toString();

        // Verificar si la cadena tiene exactamente 8 caracteres y solo contiene dígitos
        if (/^\d{8}$/.test(dateString)) { // formato es YYYYMMDD
            const year = dateString.substring(0, 4);
            const month = dateString.substring(4, 6);
            const day = dateString.substring(6, 8);
            return `${day}-${month}-${year}`;
        } else {
            return '';
        }
    }

    buildAntecedentesSocietariosTree(objReporteBasico: IReporteBasico | null): void {
        if (!objReporteBasico?.InformacionBasica) {
            this.antecedentesSocietariosTree = [];
            return;
        }

        const nombre = objReporteBasico.InformacionBasica.NombreORazonSocial;
        const rutEmpresa = this.rutFormatPipe.transform(
            objReporteBasico.InformacionBasica.Rut
        );

        this.antecedentesSocietariosTree = [{
            name: `${nombre} / ${rutEmpresa}`,
            children: (objReporteBasico.AntecedentesSocietarios ?? []).map(
                (socio: any) => ({
                    name: `${socio.nombre ?? ''} / ${this.rutFormatPipe.transform(socio.rut)}`
                })
            )
        }];
    }

    buildSociosTree(objReporteFinanciero: ICarpetaTributariaElectronicaReporteModel | null): void {
        const datosBasicos = objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.DatosBasicosSolicitud;
        const reporte = objReporteFinanciero?.CarpetaTributariaElectronicaReporte?.Reporte;

        if (!datosBasicos || !reporte) {
            this.sociosTree = [];
            return;
        }

        const rutEmpresa = this.numberPipe.transform(datosBasicos.Rut, '1.0-0') ?? '';
        const dvEmpresa = this.titleCasePipe.transform(datosBasicos.DV ?? '');

        this.sociosTree = [{
            name: `${rutEmpresa}-${dvEmpresa} / ${reporte.nombre ?? ''}`,
            children: (reporte.socios ?? []).map(socio => {
                const rutSocio = this.numberPipe.transform(socio.rut, '1.0-0') ?? '';
                const dvSocio = this.titleCasePipe.transform(socio.dv ?? '');

                return { name: `${socio.nombreRazonSocial ?? ''} / ${rutSocio}-${dvSocio}` };
            })
        }];
    }

    setDataSourceSocios() {
        return this.validaObjetoSocios()
            ? this.sociosDataSource
            : this.antecedentesSocietariosDataSource;
    }

    private buildAntecedentesComercialesData(objReporteBasico: IReporteBasico | null): void {
        const resumen = objReporteBasico?.AntecedentesComerciales?.Resumen;

        if (!resumen) {
            this.antecedentesComercialesData = [];
            return;
        }

        this.antecedentesComercialesData = [
            {
                concepto: 'Protestos',
                montoMiles: resumen.ProtestosMonto ?? 0,
                cantidad: resumen.ProtestoCantidad ?? 0
            },
            {
                concepto: 'Morosidades',
                montoMiles: resumen.MorosidadesMonto ?? 0,
                cantidad: resumen.MorosidadesCantidad ?? 0
            },
            {
                concepto: 'Infracciones Laborales',
                montoMiles: resumen.InfraccionesLaboralesMonto ?? 0,
                cantidad: resumen.InfraccionesLaboralesCantidad ?? 0
            },
            {
                concepto: 'Total',
                montoMiles: resumen.TotalImpagosMonto ?? 0,
                cantidad: resumen.TotalImpagosCantidad ?? 0,
            }
        ];
    }

    private buildResumenAntecedentesFinancieros(informacionBalance: any): void {
        if (!informacionBalance) {
            this.resumenFinancieroData = this.headerResumenFinanciero.map((item: any) => {
                return { concepto: this.balanceReporteFullResumenFinanciero[item] }
            });

            return;
        }

        this.periodosResumenFinanciero = informacionBalance.map((item: any) => item?.calculado?.periodo);
        this.resumenFinancieroColumns = [
            ...this.resumenFinancieroColumns,
            ...this.periodosResumenFinanciero
        ];

        this.resumenFinancieroData = this.headerResumenFinanciero.map((item: any) => {
            const row: any = { concepto: this.balanceReporteFullResumenFinanciero[item] };

            this.periodosResumenFinanciero.forEach((periodo: any) => {
                const value = informacionBalance.find((item: any) => item?.calculado?.periodo === periodo)?.calculado?.[item];

                if (item === 'periodo') {
                    row[periodo] = value;
                } else if (!this.getPercents(item)) {
                    row[periodo] = this.numberPipe.transform(value, '1.0-0');
                } else {
                    row[periodo] = this.numberPipe.transform(value, '1.0-2');
                }
            });

            return row;
        });
    }

    private getPercents(title: string): boolean {
        const valuesKeys = [
            'razonCorriente',
            'testAcido',
            'variacionenActivos',
            'variacionenPasivoExigible',
            'utilidadVentas',
            'ventaTotalIngresos',
            'roe',
            'roa',
            'dfebitda',
            'ebitdagf',
            'leverage',
            'dfPatrimonio',
            'variacionenVentas',
            'variacionenPatrimonio',
            'permanenciaCtasporCobrar'
        ];
        return valuesKeys.includes(title);
    }

    mapRegCheq(regCheq: any): any {
        return {
            DatosBasicosSolicitud: regCheq.DatosBasicosSolicitud,
            Reporte: regCheq.ReqcheckReport,
        };
    }
}
